module.exports = __webpack_public_path__ + "img/72.67d25bd5.jpg";